import { AbstractPerformanceRequirementNote } from './abstract-performance-requirement-note.model';

export class MilestonePerformanceRequirementNote extends AbstractPerformanceRequirementNote {
	milestone_completed: string;
	months_since_last_milestone: number;
}
